import React from 'react';
import { FaPlay, FaYoutube } from 'react-icons/fa';
import styles from './YouTube.module.css';
import { useLanguage } from '../../context/LanguageContext';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

interface VideoCard {
  id: string;
  title: string;
  tag: string;
  views: string;
}

const videos: VideoCard[] = [
  {
    id: 'MEjxC2Z4t8k',
    title: "Html Dersleri - Ders 1 | Html nedir?",
    tag: 'HTML',
    views: '72K',
  },
  {
    id: 's46aBco93Rw',
    title: 'Dreamweaver ile Kodsuz Site Yapılışı - Ders 1',
    tag: 'Dreamweaver',
    views: '32K',
  },
  {
    id: 'FcDMyqMdy58',
    title: "Html Dersleri - Ders 2 | Html'de metinler",
    tag: 'HTML',
    views: '17K',
  },
  {
    id: 'kUgZCrYU780',
    title: "Html Dersleri - Ders 3 | Html'de resimler",
    tag: 'HTML',
    views: '15K',
  },
  {
    id: 'sqAgzuOlRCQ',
    title: "Html Dersleri - Ders 4 | Html'de Linkler",
    tag: 'HTML',
    views: '13K',
  },
  {
    id: 'ErboCUWBKpk',
    title: 'CSS Dersleri - Ders 1 | CSS Nedir? Nasıl Kullanılır?',
    tag: 'CSS',
    views: '10K',
  },
];

const YouTube: React.FC = () => {
  const { t } = useLanguage();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="youtube" className={`section ${styles.youtube}`}>
      <div className="container">
        <div className={`section-header fade-in ${isVisible ? 'visible' : ''}`}>
          <span className="section-tag">{t.youtube.subtitle}</span>
          <h2 className="section-title">{t.youtube.title}</h2>
          <p className={styles.stats}>{t.youtube.stats}</p>
        </div>

        <div
          ref={ref as React.RefObject<HTMLDivElement>}
          className={`${styles.grid} fade-in ${isVisible ? 'visible' : ''}`}
        >
          {videos.map((v, i) => (
            <a
              key={i}
              href={`https://youtube.com/watch?v=${v.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.card}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className={styles.thumbnail}>
                <img
                  src={`https://i.ytimg.com/vi/${v.id}/hqdefault.jpg`}
                  alt={v.title}
                  className={styles.thumbImg}
                  loading="lazy"
                />
                <div className={styles.playBtn}>
                  <div className={styles.playIcon}>
                    <FaPlay size={16} />
                  </div>
                </div>
              </div>
              <div className={styles.content}>
                <h3 className={styles.videoTitle}>{v.title}</h3>
                <div className={styles.videoMeta}>
                  <span className={styles.tag}>{v.tag}</span>
                  <span className={styles.views}>{v.views} views</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className={styles.channelBtn}>
          <a
            href="https://youtube.com/@nuricanakturk"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.btn}
          >
            <FaYoutube /> {t.youtube.channelBtn}
          </a>
        </div>
      </div>
    </section>
  );
};

export default YouTube;
